import Button from '../Button';
import RichText from '../RichText/RichText';

import type { RichTextButtonProps } from '@skyscanner-internal/landing-pages-shared-types/src/types-shared/RichTextButtonProps';

const RichTextButton = (props: RichTextButtonProps) => (
  <RichText
    {...props.richTextProps}
    appendComponent={<Button {...props.buttonProps} />}
  />
);

export default RichTextButton;
